<template>

	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<div class="activities"> 
			<h4>Activiteiten detail</h4>
			<c-splitbutton class="margin-b-24" :buttons="buttons" v-if="status == $constants.status.REPARATIE"></c-splitbutton>
		</div>

		<c-table
			ref="table"
			:columns="columns"
			:endpoint="'/api/getevents/' + this.$route.params.id "
			:search="false">
		</c-table>

	</div>

</template>

<script>
import CTable from '@components/table/Table';
import CSplitbutton from '@components/Splitbutton';

export default {
	components: { CTable, CSplitbutton },
	data() {
		return {
			
		} 
	},
	props: {
		status: {
			
		}
	},
	computed: {
		columns() {
			return [
				{ name: 'created_at', label: 'Datum', component: 'CColumnDatetime', sortable: true, sort: true },
				{ name: 'created_at', label: 'Tijd',  component: 'CColumnTime', sortable: true },
				{ name: 'status.name', label: 'Omschrijving', sortable: true }
			];
		},
		buttons() {
			return [
				{
					label: 'Status bewerken',
					action: () => this.$store.dispatch('listener/emit', 'change-status'),
				}
			]
		},
	},
	methods: {
		load(){
			this.$refs.table.load();
		}
	},
	mounted(){
		this.load();
	}
}
</script>